var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7402 16.4283L15.0404 12.7285C14.8734 12.5615 14.6471 12.4688 14.4096 12.4688H13.8047C14.8289 11.1588 15.4375 9.51114 15.4375 7.71876C15.4375 3.45489 11.9826 0 7.71876 0C3.45489 0 0 3.45489 0 7.71876C0 11.9826 3.45489 15.4375 7.71876 15.4375C9.51114 15.4375 11.1588 14.8289 12.4688 13.8047V14.4096C12.4688 14.6471 12.5615 14.8734 12.7285 15.0404L16.4283 18.7402C16.7772 19.0891 17.3412 19.0891 17.6863 18.7402L18.7365 17.6901C19.0854 17.3412 19.0854 16.7772 18.7402 16.4283ZM7.71876 12.4688C5.09512 12.4688 2.96875 10.3461 2.96875 7.71876C2.96875 5.09512 5.09141 2.96875 7.71876 2.96875C10.3424 2.96875 12.4688 5.09141 12.4688 7.71876C12.4688 10.3424 10.3461 12.4688 7.71876 12.4688Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.1fe4fbbe3d31411838b69c68751c07af.svg";
export { ForwardRef as ReactComponent };